import { React, useEffect, useState } from 'react';
import { motion } from "framer-motion";
import GoToSimulation from '../../common/GoToSimulation';
import { rootRoute } from '../../../config';
import introduction_scm from '../assets/introduction_scm.jpg';
import scm_step1 from '../assets/scm_step1.png';
import scm_step2 from '../assets/scm_step2.png';
import scm_step3 from '../assets/scm_step3.png';
import scm_step4 from '../assets/scm_step4.png';
import scm_step5 from '../assets/scm_step5.png';
import scm_step6_updated from '../assets/scm_step6_updated.png';
import step6scm_easy from '../assets/step6scm_easy.png';
import step6scm_medium from '../assets/step6scm_medium.png';
import { useOutletContext, useNavigate, useLocation } from "react-router-dom";
import { Link } from 'react-router-dom';
import ScmModuleStyle from '../styles/scm.module.css';

const Introduction = () => {
  const [simPopup, setSimPopup, isOverlay, setIsOverlay, headerPopup, setHeaderPopup, isArtifacts, setIsArtifacts, plPopup, setPlPopup, ulPopup, setUlPopup, simPrgPopup, setSimPrgPopup, skipWalkThruPopups, isPopupShown, setIsPopupShown, accordionPopup, setAccordionPopup, simObj, setSimObj, getMonth, toggleSimulation, setToggleSimulation, startOverSimulation, isLoader, setIsLoader, setAriaProperty, check_Location] = useOutletContext();
  const navigate = useNavigate();
  const initIntro = () => {
    setSimPopup(false);
    setIsOverlay(false);
    setHeaderPopup(false);
    setIsArtifacts(false);
  }
  const [currentSection, setCurrentSection] = useState(1);
  const handleContinueBtn = () => {
    if (currentSection <= 7) {
      setCurrentSection(currentSection + 1);
    }
  };
  const location = useLocation();
  const fuSkipWalkThruPopups = () => {
    let readStatusLength = simObj?.artifacts?.filter((artifact) => artifact.readstatus == 1).length;
    return (simObj?.currentstep > 0 || simObj?.attemptno > 1 || readStatusLength > 0 || simObj?.decisionHistory != null || simObj?.decisionHistory?.length != 0)
  }
  // const check_Location = () => { 
  //   const queryParams = new URLSearchParams(location.search);
  //   if (queryParams.has('from') && queryParams.get('from') == "footer") {
  //     navigate(`${rootRoute}/im`);
  //   } else {
  //     fuSkipWalkThruPopups() && navigate(`${rootRoute}/scm/simulation`);
  //   }
  // }
  const checkNum = (num) => {
    return num < 0
      ? `-$${Math?.abs(num)?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`
      : `$${num?.toLocaleString(undefined, {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      })}`;
  };
  const formatNum = (num) => {
    return num?.toLocaleString("en-US", { style: "decimal" });
  };
  useEffect(() => {
    initIntro();
    if (document.querySelector("footer.footer .container") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .container").style.justifyContent = "center";
      }
    }
    if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
      if (fuSkipWalkThruPopups()) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "block";
      }
    }
    // if(document.querySelector(".continue-link") != null){
    //   if(fuSkipWalkThruPopups()){
    //     document.querySelector(".continue-link").style.justifyContent = "space-between";
    //   }
    // }
    if (document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").length > 0) {
      document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
        item.style.display = "none"
      });
    }
    document.title = "Supply Chain Management | Introduction";
    return () => {
      if (document.querySelector("footer.footer .container") != null) {
        document.querySelector("footer.footer .container").style.justifyContent = "space-between";
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li:not(.skip-intro)") != null) {
        document.querySelectorAll("footer.footer .footer-nav .footer-links li:not(.skip-intro)").forEach((item) => {
          item.style.display = "block"
        });
      }
      if (document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro") != null) {
        document.querySelector("footer.footer .footer-nav .footer-links li.skip-intro").style.display = "none";
      }
    }
  }, []);

  useEffect(() => {
    check_Location();
  }, [simObj]);
  return (
    <motion.div className={`${ScmModuleStyle.intro} ${ScmModuleStyle.sections}`} initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.5 }}>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 1 ? "block" : "none" }}>
        <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid}`}>
          <div className={`column ${ScmModuleStyle.column}`}>
          <h2 className={`${ScmModuleStyle['intro-heading']}`}>Introduction</h2>
            <div className={`${ScmModuleStyle.content}`}>
              <h3 className={`${ScmModuleStyle.situation}`}><strong>The Mission: </strong></h3>
              <p>You are a new supply chain analyst at AJ Manufacturing. Munson & Witt Inc. has placed a large order of your company's product. Your job is to determine the best set of suppliers to minimize procurement costs and deliver the finished product on time.</p>
              <h3 className={`${ScmModuleStyle.goal}`}><strong>Your Goal: </strong></h3>
              <p>Deliver the finished product and keep your procurement costs under {checkNum(simObj?.laststate?.totalBudget)}.</p>
            </div>
          </div>
          <div className={`column ${ScmModuleStyle.column}`}>
            <div className={`${ScmModuleStyle.image}`}>
              <img src={introduction_scm} alt="" />
            </div>  
            <div className={`${ScmModuleStyle.instr} ${ScmModuleStyle.box}`}>
              <p className={`${ScmModuleStyle.bgblue}`}>This simulation will take approximately <strong>20 minutes</strong> after you select the first order and can be paused at any time. Your score will be calculated based on how well you do relative to your goal.
              </p>
          </div>         
          </div>
          
        </div>
        <hr aria-hidden="true" />
        <div
          className={`${ScmModuleStyle['continue-link']}`}
          style={{ display: currentSection > 1 ? "none" : "flex" }}
        >
          {
            fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
              <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
            </Link>
          }
          <a href="#step1" onClick={handleContinueBtn} role="button">
            {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
          </a>
        </div>
      </div>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 2 ? "block" : "none" }}>
        <div className={`${ScmModuleStyle.step}`} id="step1">
          <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid}`}>
            <div className={`column ${ScmModuleStyle.column}`}>
            <h2>Step 1: Review Documents</h2>
              <div className={`${ScmModuleStyle.content}`}>
                <p>First you will need to go through your incoming documents: email, texts, and contracts to familiarize yourself with the scenario specifics. Read these items carefully since they contain clues on how to best understand and solve problems. Be sure to check new information, which is indicated with an alert <span className={`${ScmModuleStyle['red-circle']}`} aria-hidden="true" role='presentation'>2</span> <span className="sr-only">icon indicating 2 new items</span>.</p>
              </div>
            </div>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.image}`}>
                <img src={scm_step1} alt="An image displays a section of a webpage with an open email dialog box, along with a messages and contract icon and a list of multiple emails visible on the page." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ScmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 2 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step2" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 3 ? "block" : "none" }}>
        <div className={`${ScmModuleStyle.step}`} id="step2">
          <h2>Step 2: Request Bids</h2>
          <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid}`}>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.image}`}>
                <img src={scm_step2} alt="An image displays a section of a webpage with Request Bid and Place Orders tab." />
              </div>
            </div>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.content}`}>
                <p>Next you will request bids from suppliers. To create your finished product you need components from two different SKUs. Be sure to review the Guidelines for more detail. Each SKU can come from several different suppliers. Suppliers can change their costs and delivery schedules so you may need to request new bids throughout the simulation.</p>
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ScmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 3 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step3" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 4 ? "block" : "none" }}>
        <div id="step3" className={`${ScmModuleStyle.step}`}>
          <h2>Step 3: Review Bid</h2>
          <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid} ${ScmModuleStyle.step3main}}`}>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.content}`}>
                <p>Bids will come in over time - keep an eye out for incoming messages with bid information.</p>
              </div>
            </div>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.image}`}>
                <img src={scm_step3} alt="An image showing section of a webpage with an open email dialog box which displays bid information." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ScmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 4 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step4" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 5 ? "block" : "none" }}>
        <div id="step4" className={`${ScmModuleStyle.step}`}>
        <h2>Step 4: Place Orders</h2>
          <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid}`}>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.image}`}>
                <img src={scm_step4} alt="An image showing section of a webpage with Bids from Supplier tab selected under Place Orders tab and Request Bid tab." />
              </div>
            </div>
            <div className={`column ${ScmModuleStyle.column}`}>
             
              <div className={`${ScmModuleStyle.content}`}>
                <p>Next you will need to place your first order. Make sure you review all of your materials to make the best decisions. You will make additional ordering decisions that will impact the units you are able to manufacture and your procurement costs over the course of the simulation.</p>
              </div>
            </div>
            
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ScmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 5 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step5" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 6 ? "block" : "none" }}>
        <div id="step5" className={`${ScmModuleStyle.step}`}>
          <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid}`}>
            <div className={`column ${ScmModuleStyle.column}`}>
              <h2>Step 5: Track Final Products</h2>
              <div className={`${ScmModuleStyle.content}`}>
                <p>As the simulation begins running, each "day" takes approximately 1 second. Your required vs actual deliveries will be charted on the bottom left, while your orders by supplier with be charted on the bottom right. You will need to monitor these as they will inform future ordering decisions.</p>
              </div>
            </div>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.image}`}>
                <img src={scm_step5} alt="An image displays a section of a webpage with Total Number of Units and Units by supplier graph." />
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ScmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 6 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#step6" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div className={`${ScmModuleStyle.section}`} style={{ display: currentSection >= 7 ? "block" : "none" }}>
        <div id="step6" className={`${ScmModuleStyle.step}`}>
        <h2>Step 6: Watch Your Status</h2>
          <div className={`ui stackable two column grid ${ScmModuleStyle.ui} ${ScmModuleStyle.stackable} ${ScmModuleStyle.column} ${ScmModuleStyle.grid}`}>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.image}`}>
                <img src={((simObj?.laststate?.level == "EASY") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step6scm_easy : ((simObj?.laststate?.level == "MEDIUM") && (simObj?.hasOwnProperty("version") && simObj?.version > 1)) ? step6scm_medium : scm_step6_updated} alt={`Total ${(simObj?.userData && simObj?.userData!="") ? simObj?.userData : "gizmos"} manufactured of the year meter, Total Procurement cost of the year meter`} />
              </div>
            </div>
            <div className={`column ${ScmModuleStyle.column}`}>
              <div className={`${ScmModuleStyle.content}`}>
                <p>There are several different meters to judge how well you are doing.  They are located at the top of the simulation screen: Total finished products delivered per quarter and total procurement costs vs the budget. Check them often by hovering over them to make sure you're on track for success.</p>
              </div>
            </div>
          </div>
          <hr aria-hidden="true" />
          <div
            className={`${ScmModuleStyle['continue-link']}`}
            style={{ display: currentSection > 7 ? "none" : "flex" }}
          >
            {
              fuSkipWalkThruPopups() && <Link to={`${rootRoute}/scm/simulation`} className={`${ScmModuleStyle['skip-intro']}`} role="button">
                <span>{"Skip Intro "}<span aria-hidden="true" role="presentation">{">>"}</span></span>
              </Link>
            }
            <a href="#cardSec" onClick={handleContinueBtn} role="button">
              {"Continue "}<span aria-hidden="true" role="presentation">{">>"}</span>
            </a>
          </div>
        </div>
      </div>
      <div style={{ display: currentSection >= 8 ? "block" : "none" }}>
        <div className="key-to-succ-sec">
          <div className={`${ScmModuleStyle.bggray}`} id="cardSec">
            <div className={`${ScmModuleStyle['keys-to-succ']}`}>
              <div style={{ "paddingTop": "20px" }}>
                <h2 className={`${ScmModuleStyle['card-heading']}`}>Keys to Success</h2>
              </div>
              <div className={`${ScmModuleStyle['card-wrapper']}`}>
                <div className={`ui card ${ScmModuleStyle.ui} ${ScmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${ScmModuleStyle.header} ${ScmModuleStyle.aligned}`}>
                      <h3>Stay Informed</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${ScmModuleStyle.content} ${ScmModuleStyle.aligned}`}>
                  Your decisions are only as good as the information they are based on. Pay attention to indicators and read new messages as they come in.
                  </p>
                </div>

                <div className={`ui card ${ScmModuleStyle.ui} ${ScmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${ScmModuleStyle.header} ${ScmModuleStyle.aligned}`}>
                      <h3>Be Adaptable</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${ScmModuleStyle.content} ${ScmModuleStyle.aligned}`}>
                  This simulation puts the concepts from your course into a real-world context where circumstances are changing. Don’t be afraid to make decisions when necessary.
                  </p>
                </div>

                <div className={`ui card ${ScmModuleStyle.ui} ${ScmModuleStyle.card}`}>
                  <div>
                    <div className={`header center aligned ${ScmModuleStyle.header} ${ScmModuleStyle.aligned}`}>
                      <h3>Be Patient</h3>
                    </div>
                  </div>
                  <p className={`content center aligned ${ScmModuleStyle.content} ${ScmModuleStyle.aligned}`}>
                  Sometimes the best course of action is to see how your decisions play out over longer time periods.
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div className="section">
          <GoToSimulation />
        </div>
      </div>
    </motion.div>
  )
}

export default Introduction